import { Arch } from "@/components/Motifs";

const PHRASES = [
  { id: "intention", text: "Intention over impression" },
  { id: "room", text: "One room" },
  { id: "arrivals", text: "Two arrivals" },
  { id: "remains", text: "What remains" },
  { id: "opening", text: "A shared room is opening" },
  { id: "thread", text: "Some conversations leave a thread" },
];

const COPIES = ["primary", "loop"];

export default function Marquee() {
  return (
    <div className="th-marquee" data-testid="editorial-marquee" aria-hidden="true">
      <div className="th-marquee-track">
        {COPIES.map((copyId) => (
          <div className="th-marquee-group" key={copyId}>
            {PHRASES.map((phrase) => (
              <span className="th-marquee-item" key={`${copyId}-${phrase.id}`}>
                <em>{phrase.text}</em>
                <Arch className="th-marquee-arch" stroke="var(--muted)" sw={1} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
